import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { fetchApi } from '../../services/api';
import { getServiceTeamName } from 'utils/utils';

type State = {
  loading: boolean;
  data: Array<{ ServiceTeamID: number, Count: number }>;
  error?: string;
}

type Props = {
  filter: { Name: string, Filter: string };
}

export type TripCountByServiceTeamResponse = Array<{ ServiceTeamID: number, Count: number }>;

export default class TripCountByServiceTeam extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: true,
      data: [],
    }

    this.refreshData = this.refreshData.bind(this);
  }

  public componentDidMount() {
    this.refreshData();
  }

  public refreshData() {
    fetchApi(`/api/Report/TripCountByServiceTeam/${this.props.filter.Filter}`)
      .then((response: TripCountByServiceTeamResponse) => {
        this.setState({
          loading: false,
          data: response,
          error: undefined,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error: error?.detail || 'Failed to load data'
        });
      });
  }

  public render() {
    if (this.state.loading) {
      return <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card"></div>;
    }

    if (this.state.error) {
      return (
        <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card text-center p-3">
          <p style={{ color: '#d32f2f', marginBottom: '10px' }}>{this.state.error}</p>
          <Button onClick={this.refreshData} fillMode='flat'>
            Retry
          </Button>
        </div>
      );
    }

    return <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2 report-card">
            <p>
              <span className="report-card-title">{this.props.filter.Name} Trip Count by Service Team</span>
              <br />
              {this.state.data.reduce((a, b) => { return a + b.Count }, 0)} Trips
            </p>
            <table style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>Service Team</th>
                  <th style={{ textAlign: 'right' }}>Count</th>
                </tr>
              </thead>
              <tbody>
                {this.state.data.map((serviceTeam, index) => {
                  return <tr key={index}>
                    <td>{getServiceTeamName(serviceTeam.ServiceTeamID)}</td>
                    <td style={{ textAlign: 'right' }}>{serviceTeam.Count}</td>
                  </tr>
                })}
              </tbody>
            </table>
          </div>
  }
}
